import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

/**
 * Simple info field component with label over value
 */
const InfoField: React.FC<{ label: string; value: string | undefined; fullWidth?: boolean }> = ({
	label,
	value,
	fullWidth,
}) => {
	if (!value) return null;
	return (
		<div className={css(styleSheet.infoFieldContainer, fullWidth && styleSheet.fullWidthSection)}>
			<div className={css(styleSheet.infoFieldLabel)}>{label}</div>
			<div className={css(styleSheet.infoFieldValue)}>{value}</div>
		</div>
	);
};

/**
 * Shared component to display structured business information from discrete API fields.
 * Used by both the admin CustomContentPreferencesModal and the settings AICustomContentSection.
 * Only renders fields that have values.
 */
export const BusinessInfoDisplay: React.FC<{ profile: Api.AccountProfile | null | undefined }> = ({ profile }) => {
	if (!profile) return null;
	return (
		<div className={css(styleSheet.businessInfoGrid)}>
			<InfoField label='Location' value={profile?.location} />
			<InfoField label='Address' value={profile?.address} />
			<InfoField label='Phone number' value={profile?.phoneNumber} />
			<InfoField label='Pronouns' value={profile?.pronouns} />
			<InfoField label='Tone preference' value={profile?.tonePreference} fullWidth />

			{profile?.businessDescription && (
				<div className={css(styleSheet.fullWidthSection)}>
					<div className={css(styleSheet.infoFieldLabel)}>Description</div>
					<div className={css(styleSheet.descriptionValue)}>{profile.businessDescription}</div>
				</div>
			)}

			{profile?.contentGoals && (
				<div className={css(styleSheet.fullWidthSection)}>
					<div className={css(styleSheet.infoFieldLabel)}>Content Goals</div>
					<div className={css(styleSheet.descriptionValue)}>{profile.contentGoals}</div>
				</div>
			)}

			{profile?.messagingPreferences?.keywords && (
				<div className={css(styleSheet.fullWidthSection)}>
					<div className={css(styleSheet.infoFieldLabel)}>Keywords</div>
					<div className={css(styleSheet.infoFieldValue)}>{profile.messagingPreferences.keywords}</div>
				</div>
			)}
		</div>
	);
};
